import React from "react";
import { Grid, Card, Box, Typography, IconButton, useTheme} from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import {Droppable} from 'react-beautiful-dnd';

import Feld from "./Feld"

export default function Liste(props) {
  const {id, name, felder, dropDisabled, onClick, NeuFunktion} = props;
  const theme=useTheme()
  return(
    <Card>
      <Box p={2}>
        
        <Typography style={{fontWeight:700}}>
        {name} 
          {NeuFunktion&&
            <IconButton
              size="small"
              color="primary"
              onClick={()=>NeuFunktion()}
            >
            <AddCircleIcon/>
          </IconButton>
          }
          {!NeuFunktion&&
            <Box p={.3}></Box>
          }
        </Typography>
        
        <hr align="center" width="100%" height="2px"/>
        <Droppable 
          droppableId={id}
          isDropDisabled={dropDisabled}
        >
          {(provided, snapshot)=>(
            <div 
              ref={provided.innerRef}
              {...provided.droppableProps}  
            >
              <Box 
                p={2}
                style={(snapshot.isDraggingOver)?{backgroundColor:theme.palette.blocks.back}:{}}
              >
                <Grid container justifyContent="center">
                  {felder.map((item,index)=>{
                    return(
                      <Grid item xs={12}>    
                        <Feld id={item.key} feld={item} index={index} onClick={onClick} liste={id}/>
                      </Grid>
                    )
                  })}
                </Grid>
                {provided.placeholder}
              </Box>
            </div>
          )}
        </Droppable>
      </Box>
    </Card>
  )
}
